import { GithubOutlined, GoogleOutlined, LinkedinOutlined } from '@ant-design/icons';
import { Space, Tooltip, Divider } from 'antd';
import { redirectToProvider } from '../api/allauth';
import { useConfig } from './AuthContext';
import styles from "./ProviderList.module.css";

const ProviderList = ({ callbackURL, process = 'login' }) => {
    const config = useConfig();
    const providers = config?.data?.socialaccount?.providers || [];

    if (!providers.length) return null;

    const providerConfigMap = {
        google:   { icon: <GoogleOutlined />,  color: '#DB4437', name: 'Google' },
        github:   { icon: <GithubOutlined />,  color: '#333',    name: 'GitHub' },
        linkedin: { icon: <LinkedinOutlined />, color: '#0077B5', name: 'LinkedIn' }
    };

    const getProviderConfig = (id) =>
        providerConfigMap[id] || { icon: null, color: '#777', name: id };

    return (
        <>
            <Divider plain style={{ color: '#999' }}>
                Or continue with
            </Divider>

            <Space size="large" style={{ justifyContent: 'center', width: '100%' }}>
                {providers.map((provider) => {
                    const cfg = getProviderConfig(provider.id);

                    return (
                        <Tooltip key={provider.id} title={`Continue with ${cfg.name}`}>
                            <div
                                className={styles.socialIcon}
                                data-provider={provider.id}
                                onClick={() =>
                                    redirectToProvider(provider.id, callbackURL, process)
                                }
                            >
                                {cfg.icon}
                            </div>
                        </Tooltip>
                    );
                })}
            </Space>
        </>
    );
};

export default ProviderList;
